export default "__VITE_ASSET__df9e3728__"